module.exports = __webpack_public_path__ + "static/media/chevron-down-icon.95b711d1.svg";